import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBox2AltFill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBox2AltFill"><Path d="M3.50002 12.5L3.5 20.5H20.5V12.5M3.50002 12.5L3.50005 3.50001L20.5 3.5V12.5M3.50002 12.5H8.03095C8.2 14.4732 9.96019 16 12 16C14.0398 16 15.8 14.4732 15.9691 12.5L20.5 12.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconBox2AltFill;
